<template> 
    <section>
        <div class="text-center">
            <p class="mb-0 fw-500 fs-20 text-black-1">Log in to your account</p>
            <p class="fs-15 fw-400 text-dark-grey-1 mt-2 mb-4">Monitor and manage your applications on the job board</p>
            <div>
                <SfeButton size="lg" @click.prevent="$emit('show:login-form')" class="btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 w-100" style="padding: 14px;">Login as Applicant</SfeButton>
            </div>
            <div class="mt-3">
                <SfeButton size="lg" @click.prevent="$emit('check:user-session')" class="btn fs-18 fw-400 text-center btn-outline-primary-light-blue border-radius-8 w-100" style="padding: 14px;">Login as Admin</SfeButton>
            </div>
            <p @click.prevent="handleRegistrationLinkClick" class="mb-0 mt-4 cursor-pointer"><span class="text-primary fw-500 fs-15">Sign up</span><span class="fs-16 fw-400 text-light-grey-1 mx-2">Create an applicant account</span></p>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'LandingPage',
        data() {
            return {

            }
        },
        methods: {
            handleRegistrationLinkClick() {
                this.$store.commit('CLEAR_VERIFICATION_EMAIL')
                this.$emit('show:registration-form')
            },
        }
    }
</script>